module.exports = __webpack_public_path__ + "static/img/pic_tuigbanner@2x.7a49163c.png";